export const SOLD_SUBSCRIPTION_PAYMENT_STATUS = {
    PAID: 'paid',
    UNPAID: 'unpaid',
    PENDING: 'pending',
    PAUSED: 'paused',
    PENDING_2ND_RUN: 'pending2ndRun',
    FIRST_PAYMENT: 'first payment',
};
